import React, { useEffect } from 'react'
import { Button } from '@material-ui/core'
import CampoRemito from './CampoRemito'

function PesadoConRemitoNumero (props) {
  const { handleSubmit, exportador, planta, precargaInicial } = props

  useEffect(() => {
    if (!planta || planta === '') {
      precargaInicial()
    }
  })

  return (
    <form onSubmit={handleSubmit} className='form-numero-remito'>
      <CampoRemito
        exportador={exportador}
        planta={planta}
        resetPlanta={props.resetPlanta}
      />
      <Button
        size='medium'
        type='submit'
        style={{ visibility: 'hidden', display: 'none' }}
      >
        Siguiente
      </Button>
    </form>
  )
}

export default PesadoConRemitoNumero
